import React from "react";
import {
  ProfileContext
} from "./ProfileContext";
import { useContext } from "react";
import "./profiles.css";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import RadioButton from "./../../common/RadioButton";
import { toast, ToastContainer } from "react-toastify";
import {
  countryOptions,
  genderOptions,
  stateOptions,
  qualificationOptions,
  occupationOptions,
  annualIncomeOptions,
  maritalStatusOptions,
  feetOptions,
  inchOptions,
  foodHabitsOptions,
} from "../../constants/profileData";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PhoneNumberInput from "../../common/PhoneNumberInput";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SelectInput from "../../common/SelectInput";
import SearchableSelectInput from "../../common/SearchableSelectInput";
import MultiselectInputChipbox from "../../common/MultiselectInputChipbox";
import {updateCache} from "./ProfileContext"
import IntroCarouselModal from "../../acknowledgements/IntroCarouselModal";
import ImageUploader from './ImageUploader';

function MandatoryDetails() {
  const {
    firstName,
    setFirstName,
    firstNameError,
    setFirstNameError,
    lastName,
    setLastName,
    lastNameError,
    setLastNameError,
    dateOfBirth,
    setDateOfBirth,
    dateOfBirthError,
    setDateOfBirthError,
    timeOfBirth,
    setTimeOfBirth,
    gender,
    setGender,
    genderError,
    setGenderError,
    city,
    setCity,
    cityError,
    setCityError,
    state,
    setState,
    stateError,
    setStateError,
    country,
    setCountry,
    countryError,
    setCountryError,
    pin,
    setPin,
    pinError,
    setPinError,
    qualification,
    setQualification,
    qualificationError,
    setQualificationError,
    occupation,
    setOccupation,
    occupationError,
    setOccupationError,
    annualIncome,
    setAnnualIncome,
    annualIncomeError,
    setAnnualIncomeError,
    employedIn,
    setEmployedIn,
    employedInError,
    setEmployedInError,
    maritalStatus,
    setMaritalStatus,
    maritalStatusError,
    setMaritalStatusError,
    setHeight,
    heightFeet,
    setHeightFeet,
    heightInch,
    setHeightInch,
    weight,
    setWeight,
    weightError,
    setWeightError,
    foodHabits,
    setFoodHabits,
    foodHabitsError,
    setFoodHabitsError,
    profileImageUploadUrls,
    setProfileImageUploadUrls,
    profileImageUploadStatuses,
    setProfileImageUploadStatuses,
    localProfileImageUrls,
    setLocalProfileImageUrls,
    profileUploadDataKeys,
    setProfileUploadDataKeys,
    contactEmail,
    setContactEmail,
    fetchImageUploadData,
    contactEmailError,
    contactNumber,
    setContactNumber,
    contactNumberError,
    contactNumberCountry,
    setContactNumberCountry,
    setCachedData,
    userPreferences,
    setUserPreferences,
    userPreferencesError,
    showIntroModal,
    setShowIntroModal,
  } = useContext(ProfileContext);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if(name !== "dateOfBirth" && name !==  "qualification" && name !== "profileImage")
      updateCache(name, value, setCachedData);
    switch (name) {
      case "firstName":
        setFirstName(value);
        if(firstName!==""){
          setFirstNameError(false);
        }
        break;
      case "lastName":
        setLastName(value);
        if(lastName!==""){
          setLastNameError(false);
        }
        break;
      case "dateOfBirth":
        var today = new Date();
        var birthDate = new Date(value);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          alert("You must be 18 years old to register");
          return;
        }
        setDateOfBirth(value);
        updateCache(name, value, setCachedData);        
        if(dateOfBirth!==""){
          setDateOfBirthError(false);
        }
        break;
      case "gender":
        setGender(value);
        if(gender!==""){
          setGenderError(false);
        }
        break;
      case "city":
        setCity(value);
        if(city!==""){
          setCityError(false);
        }
        break;
      case "state":
        setState(value);
        if(state!==""){
          setStateError(false);
        }
        break;
      case "country":
        setCountry(value);
        if(country!==""){
          setCountryError(false);
        }
        break;
      case "pin":
        setPin(value);
        if(pin!==""){
          setPinError(false)
        }
        break;
      case "contactNumber":
        setContactNumber(value);
        break;
      case "contactNumberCountry":
        setContactNumberCountry(value);
          break;
      case "contactEmail":
          setContactEmail(value);
        break;
      case "userPreferences":
          setUserPreferences(value);
        break;
      case "qualification":
        var parsedValue =  typeof value === "string" ? value.split(", ") : value
        setQualification(parsedValue);
        updateCache(name, parsedValue, setCachedData);
        if(qualification!==""){
          setQualificationError(false);
        }
        break;
      case "occupation":
        setOccupation(value);
        if(occupation!==""){
          setOccupationError(false);
        }
        break;
      case "annualIncome":
        setAnnualIncome(value);
        if(annualIncome!==""){
          setAnnualIncomeError(false);
        }
        break;
      case "employedIn":
        setEmployedIn(value);
        if(employedIn!==""){
          setEmployedInError(false);
        }
        break;
      case "maritalStatus":
        setMaritalStatus(value);
        if(maritalStatus!==""){
          setMaritalStatusError(false);
        }
        break;
      case "height":
        setHeight(value);
        break;
      case "heightFeet":
        setHeightFeet(value);
        break;
      case "heightInch":
        setHeightInch(value);
        break;
      case "weight":
        const num = Number(value);
        const isDecimal = value.includes(".") && value.endsWith(".");
        const isNotInteger = isDecimal || !Number.isInteger(num) ||  value.includes("e");

        const isError = isNaN(num) || isNotInteger || isDecimal;      
        setWeight(value);
        setWeightError(value.trim() === "" || isError);
        break;
      case "foodHabits":
        setFoodHabits(value);
        if(foodHabits!==""){
          setFoodHabitsError(false);
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="p-6 mx-auto">
      <ToastContainer />
      <center>
        <h3 className="font-bold text-2xl text-center mt-3">
          Mandatory Details
        </h3>
        <p className="font-regular text-md text-center text-gray-500">
          All fields in this section are mandatory
        </p>
        <p 
          className="font-regular text-sm text-center text-blue-600 underline cursor-pointer mt-2" 
          onClick={() => setShowIntroModal(true)}>
          🔎 How GSB Soirika works?
        </p>
      </center>
      <IntroCarouselModal open={showIntroModal} handleClose={() => setShowIntroModal(false)} />
      
      <div className="mt-4">
        <h4 className="text-lg font-semibold mb-2">Profile Images</h4>
        <p className="text-md text-gray-500 mb-4">Upload <b>atleast one</b> image and up to 3 profile images. </p>
        <ImageUploader
          fetchImageUploadData={fetchImageUploadData} 
          profileImageUploadUrls={profileImageUploadUrls}
          setProfileImageUploadStatuses={setProfileImageUploadStatuses}
          localProfileImageUrls={localProfileImageUrls}
          setLocalProfileImageUrls={setLocalProfileImageUrls}
          profileImageUploadStatuses={profileImageUploadStatuses}
          setProfileImageUploadUrls={setProfileImageUploadUrls}
          profileUploadDataKeys={profileUploadDataKeys}
          setProfileUploadDataKeys={setProfileUploadDataKeys}
        />
      </div>

      <Grid container spacing={4} className="mt-5">
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="firstName"
            name="firstName"
            label="First name"
            fullWidth
            variant="outlined"
            onChange={handleChange}
            value={firstName}
            placeholder="Enter your first name"
            error={firstNameError}
            helperText={firstNameError ? "First name is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="lastName"
            name="lastName"
            label="Last name"
            fullWidth
            variant="outlined"
            onChange={handleChange}
            value={lastName}
            placeholder="Enter your last name"
            error={lastNameError}
            helperText={lastNameError ? "Last name is required" : ""}
          />
        </Grid>
        <Grid item xs={12} direction={'row'}>
						<RadioButton
							label='Gender'
							options={genderOptions}
							value={gender}
							name='gender'
							onChange={handleChange}
						/>
						{genderError && (
							<div style={{ color: 'red', fontSize: 13 }}>
								{'Please Select gender'}
							</div>
						)}
					</Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            type="date"
            required
            id="dateOfBirth"
            className="inputDate"
            name="dateOfBirth"
            label="Date of Birth"
            fullWidth
            variant="outlined"
            placeholder="DD/MM/YYYY"
            onChange={handleChange}
            value={dateOfBirth}
            error={dateOfBirthError}
            helperText={dateOfBirthError ? "Date of birth is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopTimePicker
              label={"Enter Time"}
              value={timeOfBirth}
              onChange={(value) => {
                setTimeOfBirth(value);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>

      <Grid container spacing={4} className="mt-5">
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="city"
            name="city"
            label="City"
            fullWidth
            variant="outlined"
            onChange={handleChange}
            value={city}
            placeholder="Enter your city"
            error={cityError}
            helperText={cityError ? "City is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput
            name="state"
            label="State *"
            value={state}
            handleChange={handleChange}
            fullWidth
            variant="outlined"
            placeholder="Select your State"
            options={stateOptions}
            error={stateError}
            helperText={stateError ? "State is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="pin"
            name="pin"
            label="Zip / Postal code"
            fullWidth
            variant="outlined"
            onChange={handleChange}
            value={pin}
            placeholder="Enter your pin/zip code"
            error={pinError}
            helperText={pinError ? "Pin/Zip code is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput
            name="country"
            label="Country *"
            value={country}
            handleChange={handleChange}
            fullWidth
            variant="outlined"
            placeholder="Select your Country"
            options={countryOptions}
            error={countryError}
            helperText={countryError ? "Country is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <PhoneNumberInput
            contactNumber={contactNumber}
            contactNumberCountry={contactNumberCountry}
            handleChange={handleChange}
            contactNumberError={contactNumberError}
            helperText={contactNumberError ? "Contact Number is required" : ""}
            placeholder="Enter your contact number"
            label="Contact Number"
            name="contactNumber"
            countryCodeName="contactNumberCountry"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            label="Contact Email"
            fullWidth
            name="contactEmail"
            value={contactEmail}
            error={contactEmailError}
            placeholder="Enter your Contact Email"
            onChange={handleChange}
            helperText={contactEmailError ? "Contact Email is required" : ""}
          />
        </Grid>
      </Grid>

      <Grid container spacing={4} className="mt-5">
        <Grid item xs={12} sm={6}>
          <SearchableSelectInput
            name="occupation"
            label="Occupation *"
            value={occupation}
            handleChange={handleChange}
            placeholder="Select your Occupation"
            options={occupationOptions}
            error={occupationError}
            helperText={occupationError ? "Occupation is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput
            name="annualIncome"
            label="Annual Income *"
            value={annualIncome}
            handleChange={handleChange}
            fullWidth
            variant="outlined"
            placeholder="Select your Annual Income"
            options={annualIncomeOptions}
            error={annualIncomeError}
            helperText={annualIncomeError ? "Annual Income is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="employedIn"
            label="Employed In *"
            value={employedIn}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            placeholder="Enter your Organization/Company"
            error={employedInError}
            helperText={employedInError ? "Employed In is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MultiselectInputChipbox
            name="qualification"
            label="Qualification (multiselect) *"
            value={qualification}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            placeholder="Select your Qualification"
            options={qualificationOptions}
            error={qualificationError}
            helperText={qualificationError ? "Qualification is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput
            name="maritalStatus"
            label="Marital Status *"
            value={maritalStatus}
            handleChange={handleChange}
            error={maritalStatusError}
            helperText={maritalStatusError ? "Marital Status is required" : ""}
            options={maritalStatusOptions}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container>
            <Grid xs={6}>
              <SelectInput
                name="heightFeet"
                label="Height in Feet *"
                value={heightFeet}
                handleChange={handleChange}
                options={feetOptions}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid xs={6}>
              <SelectInput
                name="heightInch"
                label="Height in Inch *"
                value={heightInch}
                handleChange={handleChange}
                options={inchOptions}
                fullWidth
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="weight"
            label="Weight *"
            value={weight}
            type="text"
            variant="outlined"
            placeholder="Weight in kg"
            onChange={handleChange}
            error={weightError}
            helperText={weightError ? "Weight is required and should be a whole number" : ""}
            fullWidth  
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput
            name="foodHabits"
            label="Food Habits *"
            value={foodHabits}
            handleChange={handleChange}
            error={foodHabitsError}
            helperText={foodHabitsError ? "Food Habit is required" : ""}
            options={foodHabitsOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>

      <Grid container spacing={4} className="mt-5">
        <Grid item xs={12}>
          <TextField
            required
            id="userPreferences"
            name="userPreferences"
            label="Partner Preferences"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            onChange={handleChange}
            value={userPreferences}
            placeholder="Describe what you are looking for in your partner"
            error={userPreferencesError}
            helperText={userPreferencesError ? "Partner preferences are required" : ""}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default MandatoryDetails;
